<template>
    <ul
        v-clickOutside:[triggerElm]="innerHide"
        :class="[size && `pt-dropdown-menu--${size}`]"
        class="pt-dropdown-menu"
        @mouseenter.stop="show"
        @mouseleave.stop="hide"
    >
        <slot></slot>
    </ul>
</template>
<script lang="ts">
import { defineComponent, getCurrentInstance, onMounted } from 'vue';
import { ClickOutside } from '../../directives';
import { useDropdown, initDropdownDomEvent } from './useDropdown';

export default defineComponent({
    name: 'PtDropdownMenu',
    directives: {
        ClickOutside,
    },
    setup() {
        const { _ptDropdownSize, ptDropdown } = useDropdown();
        const size = _ptDropdownSize.value;

        function show() {
            if (['click', 'contextmenu'].includes(ptDropdown.trigger.value)) return;
            ptDropdown.show?.();
        }
        function hide() {
            if (['click', 'contextmenu'].includes(ptDropdown.trigger.value)) return;
            _hide();
        }
        function _hide() {
            ptDropdown.hide?.();
        }

        onMounted(() => {
            const dropdownMenu = getCurrentInstance();
            initDropdownDomEvent(dropdownMenu, ptDropdown.triggerElm.value, ptDropdown.instance);
        });

        return {
            size,
            show,
            hide,
            innerHide: _hide,
            triggerElm: ptDropdown.triggerElm,
        };
    },
});
</script>
